import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { GetBy } from '../_app/cuchillo/core/Element';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import NoScroll from './NoScroll';
import ProductsScene from '../3D/ProductsScene';
import Scene from '../3D/Scene';
import Wrap from '../layout/Wrap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';

export default class Products extends NoScroll {
  scroller;

  constructor() {
    super();

    const scrollerDom = GetBy.class('__scroller', this.container)[0];

    this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
      domResize: scrollerDom,
      container: scrollerDom,
      multiplicator: 1.5,
      itemClass: InfiniteScroll__Item,
      inverted: false,
      gap: 0,
      hasVirtuaScroll: true,
    });

    ProductsScene.init(this.container, this.scroller);
  }

  beforeShow() {
    document.body.classList.add('__noScroll');
    Scroll.init();
    Keyboard.mountPage(this.id);
    if (this.isFirstTime) {
      Scene.start();
      WebGLSketch.start();
    }
    Scroll.stop();
  }

  afterShow() {
    super.afterShow();

    Scene.showBGSphere();

    this.scroller.show();
    this.scroller.start();
    ProductsScene.show();

    // Sempre: posa el character a la posició de Products i activa rotació per scroll
    const targetEl = GetBy.class('__character-target', this.container)[0];
    if (targetEl) Scene.setCharacterState('PRODUCTS', targetEl);

    // Setup complet si el character no era visible (guarda dins initCharacterForProducts)
    Scene.initCharacterForProducts(this.container);
  }

  loop() {
    super.loop();
    this.scroller.loop();
    ProductsScene.loop();
  }

  beforeHide() {
    Scene.hideCharacter(0.5);
    ProductsScene.hide();
    super.beforeHide();
  }

  hide__effect() {
    Scroll.hide();
    Wrap.hide(() => { this.afterHide() }, { delay: 1 });
  }

  afterHide() {
    Scene.resetCharacterToHome();
    ProductsScene.dispose();
    this.scroller.hide();
    this.scroller.dispose();
    super.afterHide();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    this.scroller.resize();
    ProductsScene.resize();
  }
}

ControllerPage._addPage('page-products', Products);
